/* global window */

var lodash

if (typeof require === 'function') {
  try {
    lodash = require('lodash')
  } catch (e) {}
}

if (!lodash) {
  lodash = window._
}

module.exports = lodash



//////////////////
// WEBPACK FOOTER
// ./~/graphlibrary/lib/lodash.js
// module id = 53
// module chunks = 0